import type { TableHeadCellProps } from './transaction-history.types';

export const TABLE_HEAD: TableHeadCellProps[] = [
  { id: 'expand', label: '', dataTestId: 'table-head-expand' },
  { id: 'submissionId', label: 'Submission ID', dataTestId: 'table-head-submission-id' },
  { id: 'transactionType', label: 'Transaction Type', dataTestId: 'table-head-transaction-type' },
  { id: 'receivedDate', label: 'Received Date', dataTestId: 'table-head-received-date' },
  { id: 'issueDate', label: 'Issue Date', dataTestId: 'table-head-issue-date' },
  { id: 'transactionStatus', label: 'Status', dataTestId: 'table-head-status' },
];
